<cb-dialog [dialogHeading]="dialogHeading()">
    <form #lotSpecItemForm="ngForm">
        <cb-select
            label="House Area"
            name="name"
            [(ngModel)]="mappedItem.specGroupId"
            [options]="houseAreas"
            [disabled]="data.lockedSpecGroupId != null || data.locked || !isEditOrAdd()"
            [required]="true"
        ></cb-select>
        <cb-select
            label="Cost Type"
            name="costType"
            [(ngModel)]="mappedItem.costType"
            [options]="lotSpecCostTypes"
            [disabled]="data.locked || isQuoted() || !isEditOrAdd()"
            [required]="true"
            (change)="clearProductForCostType()"
        >
        </cb-select>
        @if (displayProductSearch()) {
            <div class="start-center flex-row">
                <cb-product-autocomplete-scroller
                    class="cb-margin-right flex"
                    label="Product"
                    name="product"
                    [(ngModel)]="selectedProduct"
                    [required]="true"
                    [requireMatch]="isActual()"
                    [matchProps]="['id']"
                    [hideCompositeItems]="false"
                    (searchTextChanged)="productSearchTextChanged($event)"
                    (optionSelected)="productUpdate($event)"
                >
                </cb-product-autocomplete-scroller>
                <!-- <div ng-messages="searchForm.product.$error"
        ng-if="searchForm.product.$touched">
        <div ng-message="mat-require-match">Please select a Product</div>
      </div> -->
                <cb-product-input-find
                    name="selectedProduct"
                    (productSelected)="productUpdate($event)"
                    [required]="true"
                    [buttonOnly]="true"
                    [activeOnly]="true"
                    [hideCompositeItems]="true"
                ></cb-product-input-find>
            </div>
        }
        @if (!canSelectProduct() || data.locked) {
            <cb-text-area
                label="Product Description"
                name="productDesc"
                [(ngModel)]="productSearchText"
                [readonly]="data.locked || !isEditOrAdd()"
                (change)="clearProductForDescriptive()"
                [required]="true"
                [maxlength]="250"
            ></cb-text-area>
        }
        @if (productSearchText || selectedProduct) {
            <mat-card class="cb-margin flex-row">
                <mat-card-content>
                    <div
                        id="imageUploadDropzone"
                        class="cb-margin-right flex-col"
                        style="max-width: 180px"
                    >
                        <div class="start-center flex-row flex">
                            @if (isActual() || !specImageUrl) {
                                <cb-image-button
                                    class="flex"
                                    [baseUrl]="mappedItem.image"
                                ></cb-image-button>
                            }
                            @if (!isActual() && specImageUrl) {
                                <cb-image-button
                                    class="flex"
                                    [baseUrl]="specImageUrl"
                                ></cb-image-button>
                            }
                        </div>
                        <input
                            type="file"
                            hidden
                            #fileInput
                            (click)="$event.target.value = null"
                            accept=".jpg,.jpeg,.png,.gif,image/jpeg,image/gif,image/png"
                            (change)="uploadFile(lotSpecItemForm, $event.target.files)"
                            [disabled]="uploadingImage || isActual()"
                        />
                        @if (!isActual()) {
                            <button
                                class="cb-margin-top"
                                mat-raised-button
                                (click)="fileInput.click()"
                                [disabled]="uploadingImage"
                            >
                                <mat-icon>file_upload</mat-icon>
                                @if (mappedItem.image || specImageUrl) {
                                    <span>&nbsp;Replace Image</span>
                                }
                                @if (!mappedItem.image && !specImageUrl) {
                                    <span>&nbsp;Upload Image</span>
                                }
                            </button>
                        }
                        <button
                            class="cb-margin-top"
                            mat-raised-button
                            [hidden]="!mappedItem.canRemoveImage || isActual() || !specImageUrl"
                            (click)="removeImage(lotSpecItemForm)"
                        >
                            <mat-icon>delete</mat-icon>
                            &nbsp;Remove Image
                        </button>
                    </div>
                    @if (productSearchText && !isDescriptiveOnly()) {
                        <div class="flex-col flex">
                            <span class="mat-body-2 cb-margin-bottom">{{ getProductPath() }}</span>
                            @for (attr of skinnyProduct?.restrictions; track attr) {
                                <cb-select
                                    [name]="attr.name"
                                    [label]="attr.name"
                                    [(ngModel)]="productOptions[attr.attributeId]"
                                    noOptionsMessage="-"
                                    [readonly]="!isEditOrAdd()"
                                    [options]="attr.options"
                                ></cb-select>
                            }
                            @if (displayQuantity() && !data.locked) {
                                <cb-input
                                    type="number"
                                    label="Quantity"
                                    name="quantity"
                                    [(ngModel)]="mappedItem.quantity"
                                    [required]="true"
                                    [suffix]="productUom"
                                >
                                </cb-input>
                            }
                            @if (displayQuantity() && data.locked) {
                                <cb-display-value-new label="Quantity">
                                    {{ mappedItem.quantity }} x {{ productUom }}
                                </cb-display-value-new>
                            }
                            @if (showRate() && !(isProvisional() || isQuoted())) {
                                <cb-currency
                                    class="currency-width"
                                    [label]="getRateLabel()"
                                    name="rateInput"
                                    [(ngModel)]="mappedItem.rate"
                                    [readonly]="data.locked || !isEditOrAdd()"
                                    [required]="true"
                                ></cb-currency>
                            }
                            @if (isProvisional() || isQuoted()) {
                                <cb-currency
                                    class="currency-width"
                                    [label]="getRateLabel()"
                                    name="rateInputGst"
                                    [inclGst]="true"
                                    [(ngModel)]="mappedItem.rate"
                                    [readonly]="data.locked || !isEditOrAdd()"
                                    [required]="isRateRequired()"
                                ></cb-currency>
                            }
                            @if (displaySupplier()) {
                                <cb-select
                                    label="Supplier"
                                    name="supplier"
                                    [(ngModel)]="mappedItem.supplierId"
                                    [options]="suppliers"
                                    [readonly]="!canEditSupplier()"
                                    [required]="isRateRequired()"
                                ></cb-select>
                            }
                        </div>
                    }
                </mat-card-content>
            </mat-card>
        }
        @if (shouldShowQuoteRequired()) {
            <cb-checkbox
                label="Quote Required"
                name="quoteRequired"
                [(ngModel)]="mappedItem.quoteRequired"
                [readonly]="!isEditOrAdd()"
            >
            </cb-checkbox>
        }
        @if (isEditOrAdd()) {
            <div class="cb-checkbox-list flex-col">
                <cb-checkbox
                    label="Include in Flyer / Create Schedule"
                    name="includeCreateSchedule"
                    [(ngModel)]="mappedItem.showInClientSpecification"
                ></cb-checkbox>
                <cb-checkbox
                    label="Include In Colour Schedule"
                    name="showInColourYourDreams"
                    [(ngModel)]="mappedItem.showInColourYourDreams"
                    #includeInColourSchedule
                ></cb-checkbox>
                <cb-checkbox
                    label="Manual Colour Entry Required"
                    name="manualColourEntryRequired"
                    (change)="manualColourEntryRequiredChanged($event)"
                    [(ngModel)]="mappedItem.manualColourEntryRequired"
                ></cb-checkbox>
            </div>
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="saveDisabled(lotSpecItemForm)"
            (cbClick)="saveItem(lotSpecItemForm)"
            [clickLimit]="1"
        >
            Save
        </button>
        <button mat-raised-button (cbClick)="cancel(lotSpecItemForm.dirty)">Cancel</button>
    </div>
</cb-dialog>
